import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Modal, Header, Button, Input, TextArea, Form } from 'semantic-ui-react';
import { ColorPicker } from 'categories/Components/ColorPicker';

const EditOption = ({
    open,
    setOpen,
    option,
    surveyOptions,
    setSurveyOptions,
    optionItem,
    surveyStrucRow,
    setSurveyStrucRow,
    setUpdateJsonFile,
}) => {
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [fr, setFr] = useState('');
    const [color, setColor] = useState('#BCBCBC');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (option) {
            setId(option.id);
            setName(option.name || '');
            setFr(option.fr || '');
            setColor(option.color || '#BCBCBC');
            setDescription(option.description || '');
        }
    }, [option]);

    function onClose() {
        setOpen(false);
    }

    function onSave() {
        const updatedOption = {
            ...option,
            name,
            fr,
            color,
            description,
        };
        const newList = (surveyOptions || []).map((o) => (o.id === option.id ? updatedOption : o));
        setSurveyOptions(newList);

        const ExcludedList = (surveyStrucRow || []).filter((sc) => sc.id !== optionItem.id);
        const UpdatedItem = { ...optionItem, options: newList };
        ExcludedList.push(UpdatedItem);
        setSurveyStrucRow(ExcludedList);
        setUpdateJsonFile(Math.random());
        setOpen(false);
    }

    return (
        <Modal open={open} onClose={onClose} size="small">
            <Modal.Header>
                <Header as="h2">Edit Option</Header>
            </Modal.Header>
            <Modal.Content>
                <Field>
                    <Label>Id</Label>
                    <Input fluid value={id} disabled />
                </Field>
                <Field>
                    <Label>Name</Label>
                    <Input fluid value={name} onChange={(e) => setName(e.target.value)} />
                </Field>
                <Field>
                    <Label>French</Label>
                    <Input fluid value={fr} onChange={(e) => setFr(e.target.value)} />
                </Field>
                <Field>
                    <Label>Description</Label>
                    <Form>
                        <TextArea value={description} onChange={(e) => setDescription(e.target.value)} />
                    </Form>
                </Field>
                <Field>
                    <Label>Color</Label>
                    <ColorPicker color={color} setColor={(c) => setColor(c.hex)} />
                </Field>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Cancel</Button>
                <Button color="violet" onClick={onSave}>Save</Button>
            </Modal.Actions>
        </Modal>
    );
};

export default EditOption;

const Field = styled.div`
    margin: 10px 0;
`;

const Label = styled.div`
    margin-bottom: 6px;
    font-weight: bold;
`;


